import Pushy from '@cmyee/pushy/js/pushy.min.js';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

window.Pushy = Pushy;
window.Swiper = Swiper;

$(document).ready(function () {

    setStickyNavbar();
    closePushy();
    initializeAddProductToCart();
    initializePopovers();
    whatsappWidget();

    $(window).on("resize", function () {
        setStickyNavbar();
        closePushy();
    });

    $(document).scroll(function () {
        setStickyNavbar();
    });

    function setStickyNavbar() {
        let $nav = $('.main-navbar.navbar-sticky');

        $nav.toggleClass('scrolled', $(document).scrollTop() > ($nav.height() / 2));
    }

    function closePushy() {
        if ($(window).width() >= 991) {
            $('body').removeClass("pushy-open-right");
        }
    }

    function initializeAddProductToCart() {
        $(".single-product-quantity").each(function () {
            $(this).find(".btn-quantity-minus").on('click', function() {
                let input = $(this).next("input[type=number]");
                let minValue = input.attr('min') || 1;

                let value = parseInt(input.val(), 10);
                if (value > minValue) {
                    value -= 1;
                    input.val(value).trigger('change');
                } else {
                    input.val(value).trigger('change');
                }
                return false;
            });

            $(this).find(".btn-quantity-plus").on('click', function() {
                let input = $(this).prev("input[type=number]");
                let maxValue = input.attr('max') || 100;

                let value = parseInt(input.val(), 10);

                if (value < maxValue) {
                    value += 1;
                    input.val(value).trigger('change');
                } else {
                    input.val(value).trigger('change');
                }
                return false;
            });
        });
    }

    function initializePopovers() {
        $('[data-toggle="popover"]').popover();
    }

    function whatsappWidget() {
        $('.whatsapp-widget').each(function () {
            $(this).hide().delay(2000).fadeIn();
        });
    }
});
